import React from 'react'
import SectionHeader from './SectionHeader'
import { ISectionHeaderIndexProps } from './interface'

export default SectionHeader as React.FC<ISectionHeaderIndexProps>
